import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import { useTranslation } from 'react-i18next';
import { translationKeys } from './i18n/en';
import { Grid, Badge, HTMLParser } from '@gik/ui';
import FeatureContent from '../FeatureContent';

export const FeaturesStepsGridBlockName = 'feature-steps-grid';

export default function FeatureStepsGrid(): React.ReactElement {
  const bem = bemBlock(FeaturesStepsGridBlockName);
  const { t } = useTranslation();
  const blockClasses = bem(null, null);

  return (
    <Grid className={blockClasses}>
      <FeatureContent
        variant="primary"
        title={
          <div className={bem('feature_title')}>
            <Badge className={bem('badge')} variant="primary" circle block size="lg">
              1
            </Badge>
            <br />
            <h2 className={bem('title_copy')}>{t(translationKeys.createTitle)}</h2>
          </div>
        }
        titleCentered
      >
        <div className="gik-visible-sm">{HTMLParser({ rawHtml: t(translationKeys.createDescription) })}</div>
      </FeatureContent>

      <FeatureContent
        variant="danger"
        title={
          <div className={bem('feature_title')}>
            <Badge className={bem('badge')} variant="danger" circle block size="lg">
              2
            </Badge>
            <br />
            <h2 className={bem('title_copy')}>{t(translationKeys.customizeTitle)}</h2>
          </div>
        }
        titleCentered
      >
        <div className="gik-visible-sm">{HTMLParser({ rawHtml: t(translationKeys.customizeDescription) })}</div>
      </FeatureContent>
      <FeatureContent
        variant="secondary"
        title={
          <div className={bem('feature_title')}>
            <Badge className={bem('badge')} variant="secondary" circle block size="lg">
              3
            </Badge>
            <br />
            <h2 className={bem('title_copy')}>{t(translationKeys.shareTitle)}</h2>
          </div>
        }
        titleCentered
      >
        <div className="gik-visible-sm">{HTMLParser({ rawHtml: t(translationKeys.shareDescription) })}</div>
      </FeatureContent>

      <div className="gik-hidden-sm">{HTMLParser({ rawHtml: t(translationKeys.createDescription) })}</div>

      <div className="gik-hidden-sm">{HTMLParser({ rawHtml: t(translationKeys.customizeDescription) })}</div>

      <div className="gik-hidden-sm">{HTMLParser({ rawHtml: t(translationKeys.shareDescription) })}</div>
    </Grid>
  );
}
